import { Link } from "react-router-dom";
import { ChatCircleText, Sparkle, SpeakerHigh, VideoCamera, Image as ImageIcon } from "@phosphor-icons/react";
import { HUB_META, formatRelative } from "../lib/api";
import AuthorAvatar from "./AuthorAvatar";

function mediaIcon(t) {
  if (t === "video") return <VideoCamera size={12} weight="bold" />;
  if (t === "audio") return <SpeakerHigh size={12} weight="bold" />;
  if (t === "image") return <ImageIcon size={12} weight="bold" />;
  return null;
}

export default function PostCard({ post }) {
  const meta = HUB_META[post.hub_key] || HUB_META.aerospace;
  const mediaSrc = post.media_url?.startsWith("/api/")
    ? `${process.env.REACT_APP_BACKEND_URL}${post.media_url}`
    : post.media_url;

  return (
    <Link
      to={`/post/${post.id}`}
      className="block card card-hover p-5 reveal"
      data-testid={`post-card-${post.id}`}
    >
      <div className="flex items-center gap-2 mb-3">
        <span className="hub-dot" style={{ color: meta.color }} />
        <span className="label-mono" style={{ color: meta.color }}>
          {meta.short} · {post.hub_key.toUpperCase()}
        </span>
        <span className="label-mono">·</span>
        <span className="label-mono">{formatRelative(post.created_at)}</span>
        {post.media_type !== "none" && (
          <span className="label-mono flex items-center gap-1 ml-1">
            {mediaIcon(post.media_type)}
            {post.media_type.toUpperCase()}
          </span>
        )}
      </div>

      <h3 className="font-display text-xl md:text-2xl text-white mb-2" style={{ fontWeight: 700, letterSpacing: "-0.02em" }}>
        {post.title}
      </h3>

      {post.body && <p className="text-zinc-300 text-sm leading-relaxed line-clamp-3 mb-4">{post.body}</p>}

      {post.media_type === "image" && mediaSrc && (
        <div className="border border-[#27272A] mb-4 overflow-hidden" style={{ aspectRatio: "16/9" }}>
          <img src={mediaSrc} alt="" className="w-full h-full object-cover" loading="lazy" />
        </div>
      )}

      {post.media_type === "audio" && mediaSrc && (
        <div className="border border-[#27272A] p-3 mb-4 bg-[#0A0A0C]">
          <audio controls src={mediaSrc} className="w-full" data-testid={`post-card-audio-${post.id}`} />
        </div>
      )}

      {post.media_type === "video" && mediaSrc && (
        <div className="border border-[#27272A] mb-4 bg-black">
          <video controls src={mediaSrc} className="w-full" data-testid={`post-card-video-${post.id}`} />
        </div>
      )}

      {post.summary && (
        <div className="ai-panel p-3 mb-4">
          <div className="label-mono flex items-center gap-1.5 mb-1.5" style={{ color: "#E60012" }}>
            <Sparkle size={10} weight="fill" /> AI SUMMARY
          </div>
          <p className="text-sm text-zinc-200 leading-relaxed">{post.summary}</p>
        </div>
      )}

      <div className="flex items-center justify-between pt-3 border-t border-[#27272A]">
        <div className="flex items-center gap-2 min-w-0">
          <AuthorAvatar name={post.author_name} avatarUrl={post.author_avatar} size={24} />
          <div className="min-w-0">
            <div className="text-xs text-white truncate">{post.author_name}</div>
          </div>
          {post.author_role && post.author_role !== "public" && (
            <span className={`role-badge ${post.author_role}`}>{post.author_role}</span>
          )}
        </div>
        <div className="flex items-center gap-1.5 label-mono">
          <ChatCircleText size={12} />
          {post.reply_count} REPLIES
        </div>
      </div>
    </Link>
  );
}
